import React from 'react';
import PropTypes from 'prop-types';

import ButtonIcon from './button-icon';

const Modal = ({
	title,
	handleCancel,
	isLarge = true,
	buttons = null,
	children,
}) => {
	const handleModalContainerClick = e => {
		e.stopPropagation();
	};

	return (
		<div className="modal__background" role="presentation" onClick={handleCancel}>
			<div
				className={`modal__container ${isLarge ? 'is-large' : ''}`}
				role="presentation"
				onClick={handleModalContainerClick}
			>
				<div className="modal__title-container">
					<h2>{title}</h2>
					<ButtonIcon
						icon="xmark"
						onClick={handleCancel}
						classes="modal__close"
					/>
				</div>
				<div className={`modal__child-container ${buttons ? 'has-buttons' : ''}`}>
					{children}
				</div>
				{buttons ? (
					<div className="modal__button-container is-large">
						{buttons}
					</div>
				) : null}
			</div>
		</div>
	);
};

export default Modal;

Modal.propTypes = {
	title: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	handleCancel: PropTypes.func.isRequired,
	buttons: PropTypes.node,
	isLarge: PropTypes.bool,
};
